import React from 'react';
import { LocaleProvider } from '../useLocale';
import { LinkProvider } from '../useLink';
import I18nProvider from './lingui/I18nProvider';

export default function wrapPageElement({
  element,
  props: { pageContext, params },
}) {
  const paths = pageContext?.paths;
  const locale = params?.locale || params?.code || pageContext?.locale;
  return (
    <LocaleProvider value={locale}>
      <I18nProvider locale={locale}>
        <LinkProvider
          value={(context) =>
            context || paths ? { ...context, ...paths, locale } : undefined
          }
        >
          {element}
        </LinkProvider>
      </I18nProvider>
    </LocaleProvider>
  );
}
